var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { composeValidators, composeAsyncValidators, } from '@/utils/libs/react-final-form/validate';
import { isAllowMegaSizeFile, isFileValid, isRequiredText, strMax, } from '@/utils/validate/conditions';
/**
 * 下書きかどうかの判定
 * @param draftCheckedFunc
 */
export const draftCheck = (draftCheckedFunc) => (value, allValues, meta) => {
    const isDraft = 'isDraft' in allValues && !!(allValues === null || allValues === void 0 ? void 0 : allValues.isDraft);
    return draftCheckedFunc(isDraft)(value, allValues, meta);
};
/** ファイル選択 配列 のバリデーション */
const validateFiles = (text) => (value) => {
    const hasFile = (value === null || value === void 0 ? void 0 : value.length) && value.every((file) => file.id || file.new_file_id);
    return hasFile ? undefined : text || 'ファイルを選択してください';
};
/** 送信対象コンサルタント選択 */
export const rfpFileShareValidationSelectProfessionals = composeValidators(isRequiredText('コンサルタントを1名以上選択してください'));
/** ファイル選択 配列 */
export const rfpFileShareValidationFiles = composeValidators(validateFiles());
/** ファイル選択 object */
export const rfpFileShareValidationFile = composeValidators(isFileValid(), isAllowMegaSizeFile(100, '100MB以下のファイルを選択してください'));
export const rfpFileShareValidationFileNewId = (onInspectFileStatus) => composeAsyncValidators((value, allValues, meta) => __awaiter(void 0, void 0, void 0, function* () { return onInspectFileStatus(value, allValues, meta); }));
/** メッセージ入力 */
export const rfpFileShareValidationMessage = composeValidators(isRequiredText('メッセージを入力してください'), strMax(5000, 'メッセージは5000文字以内で入力してください'));
/**
 * メッセージ入力（下書き可能な場合）
 * @param isDraft draftCheck の結果受け取り
 */
export const rfpFileShareValidationMessageSupportedDraft = (isDraft) => composeValidators(isDraft ? null : isRequiredText('メッセージを入力してください'), strMax(5000, 'メッセージは5000文字以内で入力してください'));
